<template>
  <el-dialog
    :title="$t('app.edit')"
    :visible.sync="dialogVisible"
    width="400px"
  >
    <el-select
      v-model="rolesList"
      size="small"
      multiple
      :placeholder="$t('app.validation.select')"
      style="width: 100%"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { getValidRoleGroup } from "@/api/systemManagement/roleManagement";
import {
  getUserRole,
  allocateRolesToUser,
} from "@/api/systemManagement/userManagement";
export default {
  data() {
    return {
      dialogVisible: false,
      username: "",
      options: [],
      rolesList: [],
      loading: false,
    };
  },
  methods: {
    getList() {
      getValidRoleGroup().then((res) => {
        this.options = res.data.map((item) => {
          return {
            value: item.RoleCode,
            label: item.RoleName,
          };
        });
      });
      getUserRole({ Account: this.username }).then((res) => {
        res.data.forEach((item) => {
          this.rolesList.push(item.RoleCode);
        });
      });
    },
    edit(row) {
      this.dialogVisible = true;
      this.options.length = 0;
      this.rolesList.length = 0;
      this.username = row.account;
      this.getList();
    },
    handleClose() {
      this.$confirm(this.$t("app.confirmModification") + "?").then(() => {
        this.loading = true;
        allocateRolesToUser({
          Account: this.username,
          RoleCodeGroup: this.rolesList,
        })
          .then(() => {
            this.success();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success",
      });
      this.dialogVisible = false;
    },
  },
};
</script>
